import { Select } from 'antd';
import * as S from './styled';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

export function Top() {
  const { t } = useTranslation();
  const { lang } = useParams();
  const navigate = useNavigate();

  const lowerLang = (lang || '').toLowerCase();

  const changeLanguage = (language: string) => {
    if (language !== lang?.toLowerCase()) {
      navigate(`/${language}`);
    }
  };

  const languages = [
    { value: 'en', label: 'English', icon: <img src={`${process.env.PUBLIC_URL}/images/england.png`} alt="English" /> },
    { value: 'ja', label: 'Japan', icon: <img src={`${process.env.PUBLIC_URL}/images/japan.png`} alt="Japan" /> },
    { value: 'vi', label: 'VietNam', icon: <img src={`${process.env.PUBLIC_URL}/images/vietnam.png`} alt="VietNam" /> },

    { value: 'es', label: 'Spanish', icon: <img src={`${process.env.PUBLIC_URL}/images/spanish.png`} alt="Spanish" /> },
    { value: 'zh', label: 'Chinese', icon: <img src={`${process.env.PUBLIC_URL}/images/chinese.png`} alt="Chinese" /> },
    { value: 'hi', label: 'Hindi', icon: <img src={`${process.env.PUBLIC_URL}/images/hindi.png`} alt="Hindi" /> },
    { value: 'ar', label: 'Arabic', icon: <img src={`${process.env.PUBLIC_URL}/images/arabic.png`} alt="Arabic" /> },
    { value: 'fr', label: 'French', icon: <img src={`${process.env.PUBLIC_URL}/images/french.png`} alt="French" /> },
    {
      value: 'pt',
      label: 'Portuguese',
      icon: <img src={`${process.env.PUBLIC_URL}/images/portugal.png`} alt="Portuguese" />,
    },
    { value: 'ko', label: 'Korean', icon: <img src={`${process.env.PUBLIC_URL}/images/korean.png`} alt="Korean" /> },
  ];

  const languageList = languages.map(item => item.value);

  return (
    <S.TopStyled className="TopStyled">
      <S.TopLogoStyled>
        <img className="img-logo" src={`${process.env.PUBLIC_URL}/images/top/logo-2.png`} alt="/images/top/logo.png" />

        <S.SelectLanguageStyled
          className="choose-language"
          value={lowerLang && languageList.includes(lowerLang) ? lowerLang : 'en'}
          onChange={(val: string) => changeLanguage(val)}
        >
          {languages.map((item) => (
            <Select.Option value={item.value} key={item.value}>
              <S.OptionStyled className="OPTION_STYLED">
                {item.icon}
                <span>{item.label}</span>
              </S.OptionStyled>
            </Select.Option>
          ))}
        </S.SelectLanguageStyled>
      </S.TopLogoStyled>
      <S.TopContentStyled lang={lang}>
        <div className="text-1">{t('top.text_1')}</div>
        <div className="text-2">
          <div className="text-2-1">{t('top.text_2')}</div>
          <div className="text-2-2">{t('top.text_3')}</div>
        </div>
        <div className="text-3">
          <span>{t('top.text_4')}</span>
          <br />
          <span className="hidden-mb">{t('top.text_5')}</span>
          <br />
          <span className="hidden-mb">{t('top.text_6')}</span>
        </div>

        <S.DownloadStyled>
          <div
            className="btn"
            onClick={() =>
              window.open(
                'https://apps.apple.com/us/app/ifridge-ai-food-assistant/id6740765901',
                '_blank',
                'noopener,noreferrer',
              )
            }
          >
            <img
              className="btn-ios"
              src={`${process.env.PUBLIC_URL}/images/main-function/download-ios.png`}
              alt="/images/main-function/tick.png"
            />
          </div>
          <div
            className="btn"
            onClick={() =>
              window.open('https://play.google.com/store/apps', '_blank', 'noopener,noreferrer')
            }
          >
            <img
              className="btn-android"
              src={`${process.env.PUBLIC_URL}/images/main-function/download-android.png`}
              alt="/images/main-function/tick.png"
            />
          </div>
        </S.DownloadStyled>
      </S.TopContentStyled>

      <S.TopChefStyled>
        <img className="CHEF" src={`${process.env.PUBLIC_URL}/images/top/chef.png`} alt="/images/top/chef.png" />

        <div className="BACKGROUND">
          <img className="BG_LINE" src={`${process.env.PUBLIC_URL}/images/top/line.png`} alt="/images/top/line.png" />

          <img className="BG_DISH" src={`${process.env.PUBLIC_URL}/images/top/dish.png`} alt="/images/top/dish.png" />
        </div>
      </S.TopChefStyled>
    </S.TopStyled>
  );
}
